export const currencies = ['DKK', 'EUR', 'SEK', 'NOK', 'USD', 'GBP']
